import { API_BASE_URL, ApiError } from './client';

/**
 * What is new to me, and saying I have been shown it — TROOP-268.
 *
 * **Every answer is about the signed-in person and nobody else.** There is no call here that names
 * another person, and the server has no route that would answer one: who has seen an announcement
 * is private to them, and is never a read receipt.
 */

/** The header's count. Announcements and events are separate so a screen could say which. */
export interface WhatIsNewCount {
  announcements: number;
  events: number;
  total: number;
}

/** What a screen drew, by id. */
export interface SeenBatch {
  announcements: string[];
  events: string[];
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...init?.headers },
    ...init,
  });

  if (!response.ok) {
    throw new ApiError(response.status, `${init?.method ?? 'GET'} ${path} failed`);
  }

  return response.status === 204 ? (undefined as T) : ((await response.json()) as T);
}

/** A member's door: the unit on screen. */
export const whatsNewApi = {
  count: (unitId: string) => call<WhatIsNewCount>(`/units/${unitId}/new`),

  markSeen: (unitId: string, batch: SeenBatch) =>
    call<void>(`/units/${unitId}/seen`, { method: 'POST', body: JSON.stringify(batch) }),
};

/**
 * A parent's door: every unit their children are in. Their own seen and never their child's —
 * marking one never clears the other.
 */
export const familyWhatsNewApi = {
  count: () => call<WhatIsNewCount>('/family/new'),

  markSeen: (batch: SeenBatch) =>
    call<void>('/family/seen', { method: 'POST', body: JSON.stringify(batch) }),
};
